const countText = (error, value, limit = 500) => {
  if (error != null) return error
  return [value, limit].toString().replace(',', '/')
}

export default countText
